import React from 'react';

interface Event {
  id: number;
  name: string;
}

interface Guest {
  id: number;
  firstName: string;
  lastName?: string;
  message?: string;
  invitations: Array<{
    eventId: number;
    event: {
      id: number;
      name: string;
    };
  }>;
  rsvps: Array<{
    eventId: number;
    event: {
      id: number;
      name: string;
    };
    attending: boolean;
  }>;
}

interface GuestTableProps {
  guests: Guest[];
  events: Event[];
  onGuestClick: (guest: any) => void;
  onDelete: (guestId: number) => void;
  onUpdateRsvp: (guestId: number, eventId: number, attending: boolean | null) => void;
}

const GuestTable: React.FC<GuestTableProps> = ({
  guests,
  events,
  onGuestClick,
  onDelete,
  onUpdateRsvp,
}) => {
  const isInvitedToEvent = (guest: Guest, eventId: number): boolean => {
    return guest.invitations.some((inv) => inv.event.id === eventId);
  };

  const getRsvpStatus = (guest: Guest, eventId: number): 'yes' | 'no' | 'pending' => {
    const rsvp = guest.rsvps.find((r) => r.eventId === eventId);
    if (!rsvp) return 'pending';
    return rsvp.attending ? 'yes' : 'no';
  };

  return (
    <section className="table-card">
      <div className="table-container">
        <table className="modern-table">
          <thead>
            <tr>
              <th className="sticky-col">Prénom</th>
              <th className="sticky-col-2">Nom</th>
              {events.map((event) => (
                <th key={event.id}>{event.name}</th>
              ))}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {guests.map((guest) => (
              <tr
                key={guest.id}
                onClick={() => onGuestClick(guest)}
                style={{ cursor: 'pointer' }}
              >
                <td className="sticky-col">{guest.firstName}</td>
                <td className="sticky-col-2">{guest.lastName || '-'}</td>
                {events.map((event) => {
                  const invited = isInvitedToEvent(guest, event.id);
                  const status = getRsvpStatus(guest, event.id);

                  if (!invited) {
                    return (
                      <td key={event.id} className="not-invited">
                        <span className="badge badge-gray">Non invité</span>
                      </td>
                    );
                  }

                  return (
                    <td key={event.id}>
                      <select
                        value={status}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === 'pending') {
                            onUpdateRsvp(guest.id, event.id, null);
                          } else {
                            onUpdateRsvp(guest.id, event.id, val === 'yes');
                          }
                        }}
                        onClick={(e) => e.stopPropagation()}
                        className={`status-select status-${status}`}
                      >
                        <option value="pending">-</option>
                        <option value="yes">Oui</option>
                        <option value="no">Non</option>
                      </select>
                    </td>
                  );
                })}
                <td>
                  <button
                    className="icon-btn delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(guest.id);
                    }}
                    title="Supprimer"
                  >
                    ✕
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default GuestTable;
